'use strict';
// http://stackoverflow.com/a/24921498/2108024
/**
 * include an element and replace it's content. This removes the wrapping DIV when doing an include.
 */

angular.module('msUtility').directive('includeReplace', function () {
  return {
    require: 'ngInclude',
    restrict: 'A',
    link: function link(scope, ele) {
      ele.replaceWith(ele.children());
    }
  };
});